/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Divider, Input, ModalBody, ModalFooter, ModalHeader, Select, SelectItem } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { TeacherGroupService } from '../../../../services';
import { IconTrash } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { Constants, copy } from '../../../../utils';

const TYPES_EDUCATION = [
  { value: Constants.TYPES_EDUCATION.INITIAL, label: 'Inicial'},
  { value: Constants.TYPES_EDUCATION.PRIMARY, label: 'Primaria'},
  { value: Constants.TYPES_EDUCATION.MEDIA_GENERAL, label: 'Media General'},
]


const ModalCreateMultipleSection = ({ onSuccess, onClose, currentSchoolYearId }) => {
  const { addSection, form, onChange, onSubmit, removeSection, sections } = useForm(currentSchoolYearId);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Nuevo</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex flex-col flex-1 gap-4">
          <Input
            label="Grado"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form._grade}
            onValueChange={v => onChange(v, '_grade')}
          />

          <Select
            label="Nível"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            disallowEmptySelection
            selectedKeys={form._type ? new Set([String(form._type)]) : new Set()}
            onSelectionChange={(keys) => {
              const value = Array.from(keys)[0]; // string
              onChange(value ? Number(value) : '', '_type'); // lo guardas como number
            }}
          >
            {TYPES_EDUCATION.map((item) => (
              <SelectItem key={String(item.value)} value={String(item.value)}>
                {item.label}
              </SelectItem>
            ))}
          </Select>

          <Input
            label="Sección"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form._section}
            onValueChange={v => onChange(v, '_section')}
          />

          <Button
            variant="flat"
            onClick={addSection}
            isDisabled={!form._grade || !form._type || !form._section}
          >
            Agregar
          </Button>

          <Divider />

          {!!sections.length && (
            <div className="text-sm font-medium">
              <div className="grid grid-cols-3 bg-default-100 p-2 rounded-lg">
                <span>Grado</span>
                <span>Secciones</span>
                <span></span>
              </div>
              {sections.map((section, sectionIdx) => (
                <div key={sectionIdx} className="grid grid-cols-3 p-2 border-b border-default-200">
                  <div>
                    <span className='capitalize'>{section.name}</span>
                  </div>
                  <div className='uppercase'>
                    {section?.sections?.join(', ')}
                  </div>
                  <div className="flex justify-end">
                    <IconTrash className="cursor-pointer" onClick={() => removeSection(section)} />
                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (currentSchoolYearId) => {
  const initialForm = {
    _grade: '',
    _type: '',
    _section: '',
    sections: [],
  };
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [sections, setSections] = useState([]);
  const [mappedSections, setMappedSections] = useState([]);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const addSection = () => {
    if (!form._grade || !form._type || !form._section) return;

    const findSection = sections.find(x => {
      const grade = x.school_grade_name?.trim()?.toLowerCase() === form._grade?.trim()?.toLowerCase()
      const type  = Number(x.school_grade_type) === Number(form._type)
      const section = x.name?.trim()?.toLowerCase() === form._section?.trim()?.toLowerCase()
      return grade && type && section;
    });

    if (findSection) {
      return onError(`La sección ${form._section} ya la registró para ${form._grade}`);
    }

    setSections([
      ...sections,
      {
        school_grade_name: form._grade.trim().toLocaleLowerCase(),
        school_grade_type: Number(form._type),
        name: form._section.trim().toLocaleLowerCase(),
      }
    ]);

    setForm(s => ({
      ...s,
      _section: '',
    }));
  }

  const removeSection = (section) => {
    setSections(sections.filter((x) => x.school_grade_name !== section.name));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!sections.length)
      return onError('Debe indicar al menos una sección');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    try {
      await TeacherGroupService.groups.createSections({
        professor_id: user.id,
        school_year_id: currentSchoolYearId,
        sections
      });
      toast.success('Grado creado correctamente');
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  useEffect(() => {
    const mapped = Object.values(
      sections.reduce((acc, item) => {
        const key = `${(item.school_grade_name ?? '').trim().toLowerCase()}::${Number(item.school_grade_type)}`;
        if (!acc[key]) {
          acc[key] = {
            name: (item.school_grade_name ?? '').trim().toLowerCase(),
            type: Number(item.school_grade_type),
            sections: new Set(),
          };
        }
        acc[key].sections.add((item.name ?? '').trim().toLowerCase());
        return acc;
      }, {})
    ).map(group => ({
      ...group,
      sections: Array.from(group.sections)
    }));

    setMappedSections(mapped);
  }, [sections]);


  return {
    addSection,
    form,
    onChange,
    onSubmit,
    removeSection,
    sections: mappedSections,
  }
}

export default ModalCreateMultipleSection;
